import styled from "styled-components";
import theme from "../../../../styles/theme";

export const DatagridContainer = styled.div<{
  disableHeight?: boolean;
}>`
  display: flex;
  width: 100%;
  height: ${props => (props.disableHeight ? "auto" : "75vh")};
  align-self: center;
  flex-direction: column;
  @media ${theme.devices.tablet} {
    width: 90vw;
    height: 100%;
    max-height: 78vh;
  }
`;
export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2vw;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    justify-self: center;
    display: flex;
    width: 100%;
  }
`;
